import Workspace from '@/models/workspace';
import _ from 'lodash';
import { getWorkspaceId, saveWorkspaceId } from '@/utils/token';
import { getWs, getWsList, updateUrlWsData } from '@/container/HomePage/slice/workspaceSlice';

export const getWsListApi = () => async dispatch => {
  try {
    const data = await Workspace.getWsList();
    if (!_.isEmpty(data) && data.length === 1 && _.isEmpty(getWorkspaceId())) {
      saveWorkspaceId(data[0]._id);
    }
    dispatch(getWsList(data));
    return { data, isSuccess: true };
  } catch (error) {
    return { error, isError: true };
  }
};

export const getWsApi = (workspace_id) => async dispatch => {
  try {
    const data = await Workspace.getWs({ workspace_id });
    dispatch(getWs(data));
    return { data, isSuccess: true };
  } catch (error) {
    return { error, isError: true };
  }
};

export const getUrlWsApi = (workspace_id) => async dispatch => {
  try {
    const data = await Workspace.getWs({ workspace_id });
    dispatch(updateUrlWsData(data));
    return { data, isSuccess: true };
  } catch (error) {
    return { error, isError: true };
  }
};
